import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const SegmentTag = styled(Box)`
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => getThemeColor('grey_4', theme)};
`
